import css from 'styled-jsx/css'

import { sizes } from '../../theme'


export default css`
  .container {
  }

  .container :global(a) {
    text-decoration: none;
    transition: opacity 150ms ease;
    display: flex;
    align-items: center;
  }

  .container :global(a:hover),
  .container :global(a:active) {
    opacity: 0.6;
  }

  .container :global(.icon:not(.right)) {
    margin-right: 2rem;
  }

  .container :global(.icon.right) {
    margin-left: 1rem;
  }


  .container.left :global(.icon) {
    transform: scaleX(-1);
  }
  
  @media screen and (max-width: ${sizes.media.tablet.maxWidth}) {
      .container :global(.icon img) {
        width: 30px;
      }
  }
`
